/* eslint-disable no-unused-vars */
import * as mm from '../../../services/memberManagement';

export default {
  namespace: 'dgic',

  state: {
    getNodeInputItemTable: null,
    saveGraphTable: null,
    getItemNodeSelect: null,
  },

  effects: {
    // 获取入参配置列表
    *getNodeInputItemTable({ payload: { values } }, { call, put }) {
      const { data: response } = yield call(mm.getNodeInputItemTable, values);
      yield put({
        type: 'save',
        payload: {
          getNodeInputItemTable: response,
        },
      });
    },
    //保存配置列表
    *saveGraphTable({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(mm.saveGraphTable, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          saveGraphTable: response,
        },
      });
    },
    //获取每个节点的下拉选择
    *getItemNodeSelect({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(mm.getItemNodeSelect, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          getItemNodeSelect: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
